import { render, staticRenderFns } from "./PropagatePriceToOrders.vue?vue&type=template&id=7cfe3402&"
import script from "./PropagatePriceToOrders.vue?vue&type=script&lang=js&"
export * from "./PropagatePriceToOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports